export default __webpack_public_path__ + "static/media/CNo.33-1.3ed9834c.jpg";